import _ from 'lodash';

export function has<T>(key: string): (T) => boolean {
  return (t: T) => _.has(t, key);
}
export function hasNot<T>(key: string): (T) => boolean {
  return _.negate(has(key));
}
export function get<T extends object, K extends keyof T>(key: K): (T) => T[K] {
  return (t: T) => _.get(t, key);
}
export function is<T extends object>(key: string): (T) => boolean {
  return (t: T) => !!_.get(t, key);
}
export function isNot<T>(key: string): (T) => boolean {
  return _.negate(is(key));
}
export function equal<T, K>(key: string, value: K): (T) => boolean {
  return (t) => _.eq(_.get(t, key), value);
}
export function notEqual<T, K>(key: string, value: K): (T) => boolean {
  return _.negate(equal(key, value));
}
